import React from "react"
import {useAccessToken} from "../../../services/auth"
import useAsyncResultIdle from "../../../hooks/useAsyncResultIdle"
import {patchProductApplicationBeneficialOwner} from "../../../resources/productApplication"
import ConfirmationModalContent from "../../ReevaluateApplication/ReevaluateConfirmationModal/ConfirmationModalContent"
import {ReevaluatedBeneficialOwnerApplicationData} from "../../ReevaluateApplication/Forms/ReevaluateBeneficialOwnerForm/ReevaluateBeneficialOwnerForm"

export default function ReevaluateProductApplicationBeneficialOwnerConfirmationModal(props: {
	close: () => void
	onSuccess: () => void
	productApplicationId: string
	beneficialOwnerId: string
	reevaluatedData: ReevaluatedBeneficialOwnerApplicationData
}) {
	const {close, onSuccess, productApplicationId, beneficialOwnerId, reevaluatedData} = props
	const accessToken = useAccessToken()
	const [updateRequest, setUpdateRequest] = useAsyncResultIdle(patchProductApplicationBeneficialOwner)

	const handleSubmit = (reason: string) => {
		const data = {
			address: reevaluatedData.address,
			email: reevaluatedData.email,
			phone: reevaluatedData.phone,
			percentage: reevaluatedData.percentage,
			occupation: reevaluatedData.occupation,
			annualIncome: reevaluatedData.annualIncome,
			sourceOfIncome: reevaluatedData.sourceOfIncome,
		}

		setUpdateRequest(accessToken, productApplicationId, beneficialOwnerId, data, reason)
	}

	return (
		<ConfirmationModalContent
			state={updateRequest}
			close={close}
			onSubmit={handleSubmit}
			onSuccess={onSuccess}
			enableReevaluateApplication={true}
		/>
	)
}
